import { useController } from 'react-hook-form';
import InputImgUploader from '.';

export const InputImgUploaderController = (props) => {
    const { control, name, onChange, onBlur, children, ...rest } = props;
    const { field, fieldState } = useController({
        name,
        control,
    });

    return (
        <InputImgUploader
            onChange={(value) => {
                const forwardedValue = !value ? null : value;
                onChange && onChange(forwardedValue);
                field.onChange(forwardedValue);
            }}
            onBlur={(...v) => {
                onBlur && onBlur(...v);
                field.onBlur(...v);
            }}
            value={field.value}
            name={field.name}
            errorMessage={fieldState.error?.message}
            {...rest}
        >
            {children}
        </InputImgUploader>
    );
};
